import {h, Fragment} from "preact"
import { useAppStateSelector, useSelectedFiltersCount, useSort, pick } from "@nosto/preact"
import { sortOptions } from "../config"
import Icon from "./elements/Icon"
import Select from "./elements/Select"
import { toggleButtonId } from "./Sidebar"

function ToggleMobileSidebarButton({ selectedFiltersCount, className }) {
    return (
        <label
            for={toggleButtonId}
            className={`ns-act-btn ns-act-btn-light ns-filters ns-d-inline-flex ns-d-md-none ns-text-align-center ns-align-items-center ${className}`}
        >
            <Icon name="filter" />
            <span>Filter</span>
            {selectedFiltersCount > 0 && (
                <span className="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                    {selectedFiltersCount}
                </span>
            )}
        </label>
    )
}

export default function Toolbar({setGridMode, gridMode}) {
    const { loading, query, response, pageType } = useAppStateSelector(state =>
        pick(state, "loading", "query", "response", "pageType")
    )
    const { activeSort, setSort } = useSort(sortOptions)
    const selectedFiltersCount = useSelectedFiltersCount()

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    const docCount = response.products?.total ?? 0

    const totalSummary = pageType === "category" ? `${docCount} products` : `'${query.query}' - ${docCount} results`

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    return (
        <nav
            class="productgrid--utils productgrid--utils--visible-mobile"
            aria-label="Collection utilities"
        >
            <div class="productgrid--utils utils-filter">
                <label  for={toggleButtonId} class="utils-filter-button" type="button" aria-label="Filters">
                    <span class="utils-filter-icon">
                        <svg class="icon-filters" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="19" height="13" viewBox="0 0 19 13" fill="none">
                            <title>Filters icon</title>
                            <circle cx="14" cy="3" r="2"  stroke="currentColor" stroke-width="1.25"></circle>
                            <path d="M0 3H12M19 3H16" stroke="currentColor" stroke-width="1.25"></path>
                            <circle r="2" transform="matrix(-1 0 0 1 5 10)" stroke="currentColor" stroke-width="1.25"></circle>
                            <path d="M19 10H7M0 10H3" stroke="currentColor" stroke-width="1.25"></path>
                        </svg>
                    </span>
                    <span class="utils-filter-text">Filters</span>
                </label>
            </div>
            <div class="productgrid--utils utils-sortby">
                <label class="utils-sortby-title" for="product_grid_sort">Sort by</label>
                <button class="utils-sortby-button" aria-hidden="true">Sort by</button>
                <div class="utils-sortby-select form-field-select-wrapper no-label">
                    <Select
                        value={activeSort}
                        onChange={e => handleSortChange(e)}
                        className=""
                        options={options}
                        label={"Sort by"}
                    />
                </div>
            </div>
            <div class="productgrid--utils utils-view">
                <div class="utils-view-container">
                    <div class="utils-viewtoggle">
                        <span class="utils-viewtoggle-label">View as</span>
                        <button class="utils-viewtoggle-button" aria-label="grid view" onClick={() => setGridMode(true)}>
                            <svg class="icon-grid" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <title>Grid icon</title>
                                <rect x="4" y="4" width="4" height="4" stroke="currentColor" stroke-width="1.25" stroke-linejoin="round"></rect>
                                <rect x="12" y="4"  width="4"  height="4" stroke="currentColor" stroke-width="1.25" stroke-linejoin="round" ></rect>
                                <rect x="4" y="12" width="4" height="4" stroke="currentColor" stroke-width="1.25" stroke-linejoin="round"></rect>
                                <rect x="12" y="12" width="4" height="4" stroke="currentColor" stroke-width="1.25" stroke-linejoin="round"></rect>
                            </svg>
                        </button>
                        <button class="utils-viewtoggle-button active" aria-label="list view" onClick={() => setGridMode(false)}>
                            <svg class="icon-list" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <title>List icon</title>
                                <path d="M4 4.75H16" stroke="currentColor" stroke-width="1.25" stroke-linejoin="round"></path>
                                <path d="M4 15.25H16" stroke="currentColor" stroke-width="1.25" stroke-linejoin="round"></path>
                                <path d="M4 10H16" stroke="currentColor" stroke-width="1.25" stroke-linejoin="round"></path>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </nav>
    )
}
